import { createContext } from 'react';

import type { UserSettingsContextValue } from './userSettingsTypes';

export const UserSettingsContext =
	createContext<UserSettingsContextValue | null>(null);
